import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { BaseTab } from '@/components/ui/Tab/BaseTab';
export const OutlineTab = (props) => {
    const { activeValue, children, className = '', disabled, onChange, value, } = props;
    const commonClass = {
        button: clsx('text-13', 'text-center', 'p-8'),
        tab: clsx('flex items-center justify-center', 'w-full h-[60px] md:w-[260px]', 'rounded-t-md', 'translate-y-1', 'overflow-hidden', className),
    };
    const customClass = {
        button: {
            active: clsx(commonClass.button, 'text-primary font-bold'),
            inactive: clsx(commonClass.button, 'text-gray-500 font-normal'),
        },
        tab: {
            active: clsx(commonClass.tab, 'bg-white', 'base-gray', 'border-solid border', 'border-b-gray-50 border-t-navy-100 border-x-navy-100'),
            inactive: clsx(commonClass.tab, 'bg-light-gray', 'border-solid border', 'border-b-navy-100 border-t-gray-75 border-x-gray-75'),
        },
    };
    return (_jsx(BaseTab, Object.assign({ activeValue: activeValue, classNames: customClass, disabled: disabled, onChange: onChange, value: value }, { children: children })));
};
